/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_70a35574"]'><cube-button open-type="openSetting" tip="需在微信小程序环境预览" @openSetting='(e)=>__invoke(e, [["onOpenSetting"]])'>打开授权设置页面</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_70a35574"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_70a35574"}
  /** script content **/
  require("./btn-open-setting.mpx.js?isComponent&outputPath=components%2Fbtn-open-setting70a35574%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-open-setting.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-open-setting70a35574%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_70a35574"],
    ctorType: "component",
    outputPath: "components/btn-open-setting70a35574/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>